import React, { Component, Fragment } from 'react';
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import ReactDatatable from '@ashvin27/react-datatable';
import { toastr } from "react-redux-toastr"
import { Modal } from "react-bootstrap"
import Select from 'react-select'

import {
    getData, getExcUpdataUsu
    , getBrokerCmps, getUsuCmps
    , postInclui, putSalva, getExisteEmail
    , getCadAcsEmail
} from "./CadastroActions"
//import { logout, getAcessosEmail } from "./../../../auth/authActions"
import { logout } from "./../../../auth/authActions"

const cstTipoLicenca = [
    { Codigo: 1, Descricao: "Flag" },
    { Codigo: 2, Descricao: "Heineken" },
    { Codigo: 3, Descricao: "Revenda" }
];


class Cadastro extends Component {
    constructor(props) {
        super(props)

        if (this.props.codUsuario === "" || this.props.codUsuario === undefined) {
            toastr.info("Tempo do Token vencido ou sem acesso ou inválido !!!!")
            this.props.logout();
        }
        else {

            this.state = {
                infFiltro: "", isModalOpen: false
                , atuusulogin: "", atupuxid: 0
                , email: "", senha: "", SelBroker: 0, SelTipLic: 0
                , slvUSUID: 0, slvUSUEXC: false, acessosdoEmailsel: [{}]
                , usuIDparalista: 0
                , acessosdoEmailSlv: []
                , cadcmpsacsdecadaum: this.props.cmposcadacsdoEmail || []
                , listaTodosEmails: []
                , workTodosAcessos: this.props.todosCamposdeAcesso || []
                //               , camposBrokerusa: this.props.steCadcamposBroker || []

            };

            this.props.getCadAcsEmail();
            this.props.getData(this.props.TipoLicenca, (this.props.codPuxada === null ? 0 : this.props.codPuxada));
            this.props.getBrokerCmps();
            this.props.getUsuCmps(this.props.TipoLicenca, (this.props.codPuxada === null ? 0 : this.props.codPuxada));

            this.UpdateFechamento = this.UpdateFechamento.bind(this);
            this.OpenModalParam = this.OpenModalParam.bind(this);
            this.FecharModalParam = this.FecharModalParam.bind(this);
            this.setEmail = this.setEmail.bind(this);
            this.setSenha = this.setSenha.bind(this);
            this.sethCSelBroker = this.sethCSelBroker.bind(this);
            this.setSelTipLic = this.setSelTipLic.bind(this);
            this.setSelAcesso = this.setSelAcesso.bind(this);
            this.saveRole = this.saveRole.bind(this);
            this.limpavariaveis = this.limpavariaveis.bind(this);
            this.setSelCopiarde = this.setSelCopiarde.bind(this);

            this.columns = [

                {
                    key: "action1",
                    text: "",
                    className: "action1",
                    width: 30,
                    align: "center",
                    sortable: false,
                    cell: record => {
                        return (
                            <Fragment>

                                <div type="button"
                                    data-toggle="tooltip" data-placement="right"
                                    title="Editar Cadastro">
                                    <i className="Elipse-47 fa fa-pencil-square-o" aria-hidden="true"
                                        onClick={() => { this.OpenModalParam(record.usulogin, record.cod_puxada, record.usuid, record.tipo_Usu,) }}
                                    >
                                    </i>
                                </div>

                            </Fragment>
                        );
                    }
                },

                {

                    key: "action2",
                    text: "",
                    className: "action2",
                    width: 30,
                    align: "center",
                    sortable: false,

                    cell: record => {
                        return (
                            <div type="button"
                                data-toggle="tooltip" data-placement="right" title="Excluir Usuário"
                                onClick={() => { this.UpdateFechamento(record.usuid, record.usulogin) }}
                            >
                                <i className="Elipse-47 fa fa-trash" aria-hidden="true"
                                >
                                </i>
                            </div>
                        );
                    }
                },

                {
                    key: "usuid",
                    text: "Código",
                    className: "Clsusuid",
                    align: "right",
                    sortable: true,
                },
                {
                    key: "usulogin",
                    text: "Email",
                    className: "Clsusulogin",
                    align: "left",
                    sortable: true,
                    width: 400,

                },
                // {
                //     key: "ususenha",
                //     text: "Senha",
                //     className: "Clsususenha",
                //     align: "left",
                //     sortable: true,
                //     disabled: true

                // },
                {
                    key: "cod_puxada",
                    text: "Revenda",
                    className: "Clscod_puxada",
                    align: "left",
                    sortable: true,
                    width: 100,
                },
                // {
                //     key: "usuexc",
                //     text: "Excluido",
                //     className: "Clsusuexc",
                //     align: "left",
                //     sortable: true

                // },
                {
                    key: "tipo_Usu",
                    text: "Tipo Licença",
                    className: "Clstipo_Usu",
                    align: "left",
                    sortable: true,
                    width: 100,
                },
            ];
            this.config = {
                key_column: 'usuid',
                page_size: 10,
                length_menu: [10, 20, 50],
                button: {
                    excel: true,
                    print: true,
                    extra: true,
                },
                filename: "Usuarios",

                language: {
                    length_menu: "Mostrar _MENU_ registros por página",
                    filter: "Buscar em Registros ...",
                    info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                    pagination: {
                        first: "Primeira",
                        previous: "Anterior",
                        next: "Próxima",
                        last: "Última"
                    },
                    loading_text: "Aguarde buscando informações..."
                }

            }

            this.extraButtons = []
        }
    }

    openModal = () => {
        this.setState({ isModalOpen: true });
    }

    closeModal = () => this.setState({ isModalOpen: false })

    OpenModalParam(Expusulogin, Exppuxid, ExpUSUID, ExpTipLic) {

        //      this.props.getCadAcsEmail();
        this.openModal();

        this.setState({

            atuusulogin: Expusulogin
            , atupuxid: Exppuxid
            , slvUSUID: ExpUSUID
            , email: Expusulogin
            , SelBroker: Exppuxid
            , SelTipLic: ExpTipLic
            , usuIDparalista: ExpUSUID
            , acessosdoEmailSlv: this.props.cmposcadacsdoEmail
                .filter((a) => a.usuid === ExpUSUID)
                .map((ar, i) => (ar.mnuid))
            , cadcmpsacsdecadaum: this.props.cmposcadacsdoEmail || []

            , workTodosAcessos: this.state.workTodosAcessos.map((ar, i) => {
                ar.selecionado =
                    (this.props.cmposcadacsdoEmail
                        .filter((a) => Number(a.usuid) === Number(ExpUSUID)
                            && Number(a.mnuid) === Number(ar.mnuid)).length > 0 ? 2 : 1
                    )
                return ar;
            })
        });

    }

    setSelAcesso(e) {

        const array = [];

        for (let i = 0, l = e.length; i < l; i++) {
            array.push(e[i].value);
        }

        this.setState({

            workTodosAcessos: this.state.workTodosAcessos.map((ar) => {
                ar.selecionado =
                    (array
                        .filter((a) => Number(a) === Number(ar.mnuid)).length > 0 ? 2 : 1
                    )
                return ar;
            })
            , acessosdoEmailSlv: array
        });
    }

    FecharModalParam() {
        this.limpavariaveis();
        //  this.props.getCadAcsEmail();
        this.closeModal();
    }

    limpavariaveis() {
        this.setState({
            email: ""
            , atuusulogin: ""
            , atupuxid: "0"
            , senha: ""
            , SelBroker: 0
            , SelTipLic: -1
            , acessosdoEmailsel: [{}]
            , acessosdoEmailSlv: []
            , usuIDparalista: 0
            , slvUSUID: 0
            , workTodosAcessos: this.state.workTodosAcessos.map((ar, i) => {
                ar.selecionado = 0
                return ar;
            })
            //            , cadcmpsacsdecadaum: []

        })
    }

    UpdateFechamento(IdUsuario, usulogin) {

        if (this.props.codUsuario === "" || this.props.codUsuario === undefined) {
            toastr.warning("Código do Usuário Inválido")
        }
        else {
            if (this.props.nomeUsuario === usulogin) {
                toastr.warning("Não pode Excluir o Usuário Login igual ao Usuário selecionado")
            }
            else {
                if (usulogin === "AdmMaster") {
                    toastr.warning("Não pode Excluir o Usuário AdmMaster")
                }
                else {
                    var r = (window.confirm("Confirma a Exclusão do Usúario: " + usulogin))
                    if (r === true) {
                        this.props.getExcUpdataUsu(
                            IdUsuario
                            , this.props.TipoLicenca
                            , (this.props.codPuxada === null ? 0 : this.props.codPuxada)
                        )
                    }
                }
            }
        }
    }

    setEmail(e) {

        this.setState({
            email: e.target.value
        });

        if (e.target.value !== "") {
            this.props.getExisteEmail(e.target.value)
        }
    }

    setSenha(e) {
        this.setState({
            senha: e.target.value
        });
    }

    sethCSelBroker(e) {
        this.setState({
            SelBroker: e.target.value
        });
    }
    setSelTipLic(e) {
        this.setState({
            SelTipLic: e.target.value
        });
    }

    setSelCopiarde(e) {
        // vai pegar a selecao do usuario que vai copiar
        // e atualiza a variavel cadcamposacessodoemail, para
        // fazer automatico a marcacao

        this.setState({
            workTodosAcessos: this.state.workTodosAcessos.map((ar, i) => {
                ar.selecionado =
                    (this.state.cadcmpsacsdecadaum
                        .filter((a) => Number(a.usuid) === Number(e.target.value)
                            && Number(a.mnuid) === Number(ar.mnuid)).length > 0 ? 2 : ar.selecionado
                    )
                return ar;
            }),

            acessosdoEmailSlv: this.props.cmposcadacsdoEmail
                .filter((a) => Number(a.usuid) === Number(e.target.value))
                .map((ar, i) => (ar.mnuid))

        })

    }

    saveRole() {

        
        if (this.state.atuusulogin === undefined || this.state.atuusulogin === "") {
            //INCLUIR
            if (this.props.existeemail === true) {
                toastr.warning("E-mail já cadastrado")
            }
            else if (this.state.email === undefined || this.state.email === "") {
                toastr.warning("E-mail vazio ou inválido")
            }
            else if (this.state.senha === undefined || this.state.senha === "") {
                toastr.warning("Senha vazia ou inválida")
            }
            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) {
                toastr.warning('E-mail inválido')
            }
            else if (this.state.SelTipLic === undefined
                || this.state.SelTipLic === ""
                || this.state.SelTipLic === 0
                || this.state.SelTipLic === null
                || this.state.SelTipLic === -1
            ) {
                toastr.warning("Tipo de Licença, vazia ou inválida")
            }
            else {
                this.props.postInclui(
                    this.state.slvUSUID,
                    this.state.email,
                    this.state.senha,
                    this.state.slvUSUEXC,
                    this.state.acessosdoEmailSlv,
                    this.state.SelTipLic,
                    (this.state.SelBroker === 0 ? this.state.slvUSUEXC : this.state.SelBroker)
                    , this.props.TipoLicenca
                    , (this.props.codPuxada === null ? 0 : this.props.codPuxada)
                )
                //this.limpavariaveis();        
                this.FecharModalParam();
            }
        }
        else {
            //ATUALIZAR
            if (this.state.email === undefined || this.state.email === "") {
                toastr.warning("E-mail vazio ou inválido")
            }
            else if (this.state.SelTipLic === undefined
                || this.state.SelTipLic === ""
                || this.state.SelTipLic === 0
                || this.state.SelTipLic === null
                || this.state.SelTipLic === -1) {
                toastr.warning("Tipo de Licença, vazia ou inválida")
            }
            else {
                this.props.putSalva(
                    this.state.slvUSUID,
                    this.state.email,
                    this.state.senha,
                    this.state.slvUSUEXC,
                    this.state.acessosdoEmailSlv,
                    this.state.SelTipLic,
                    (this.state.SelBroker === 0 ? this.state.slvUSUEXC : this.state.SelBroker)
                    , this.props.TipoLicenca
                    , (this.props.codPuxada === null ? 0 : this.props.codPuxada)

                )
                //this.limpavariaveis();        
                this.FecharModalParam();
            }
        };

    }


    render() {
        const camposBrokerusa = this.props.steCadcamposBroker || [];
        const camposUsuariosCop = this.props.camposUsuarios || [];

        return (

            <div className="container" >

                <div className="row">
                    <div className="col-md-4">
                        {/* <span className="cadastro-Externos">Usuários / &nbsp;
                                <span className="text-style-1">Cadastro</span>
                            </span> */}
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Usuários</span>
                        </span>
                    </div>
                    <br />
                    <div className="col-md-8">
                        <button type="button" className="btn btn-success btn-sm" style={{ float: "right" }}
                            onClick={this.openModal}>Novo Usúario</button>
                    </div>
                </div>
                <br />

                <div>
                    <ReactDatatable
                        config={this.config}
                        records={this.props.listaTodosEmails || []}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    />
                </div>

                <Modal size="lg" show={this.state.isModalOpen}
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "22px"
                                , fontStyle: "Italic"
                            }}
                        >Manutenção do Usuário: &nbsp; &nbsp;
                            {(this.state.atuusulogin === undefined || this.state.atuusulogin === "" ? "Novo Usuário" : this.state.atuusulogin)}
                        </Modal.Title>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.saveRole}
                        >Salvar
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            //                            onClick={() => {this.FecharModalParam() }}
                            onClick={this.FecharModalParam}
                        >Fechar
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ color: "#77b935" }}>
                        <div className="row" >
                            <div className="col-md-12">
                                {/* <div className="form-group"> */}
                                <label>Email</label>
                                <input type="text" className="form-control"
                                    //defaultValue = {(this.state.atuusulogin === undefined || this.state.atuusulogin === "" ? undefined :  this.state.atuusulogin)}
                                    //value e Value tem direferenca (V) deixa alterar v nao deixa alterar
                                    value={(this.state.atuusulogin === undefined || this.state.atuusulogin === "" ? this.state.email : this.state.atuusulogin)}

                                    // readonly = {(this.state.atuusulogin !== undefined && this.state.atuusulogin !== "" ? true : false)}

                                    //{(this.state.atuusulogin === undefined || this.state.atuusulogin === "" ? "" : this.state.atuusulogin)}
                                    onChange={this.setEmail}
                                    placeholder="digite o nome Email ou Usuário..." maxLength="200" />
                                {/* </div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {/* <div className="form-group"> */}
                                <label>Senha</label>
                                <input type="text" className="form-control"
                                    // nao tem jeito de trazer a senha,pois, não ha conversao de cripto para qual senha
                                    // teria que criar um campo na tabela com a senha origem - nao faz sentido por causa
                                    // da segurança
                                    value={this.state.senha}
                                    onChange={this.setSenha}
                                    placeholder="digite a Senha, somente novo, alteraçao não é obrigatório..." maxLength="20" />
                                {/* </div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                {/* <div className="form-group"> */}
                                <label>Revenda:</label>
                                <select className="form-control"
                                    value={(this.props.TipoLicenca === 3 ? this.props.codPuxada : this.state.SelBroker)}

                                    onChange={this.sethCSelBroker}
                                >
                                    <option value={0}>-- Selecione um Distribuidor -- </option>

                                    {camposBrokerusa.map((ar, i) => (

                                        (this.props.TipoLicenca === 3 ?
                                            <option value={this.props.codPuxada}> {this.props.codPuxada} - Revenda </option>
                                            :
                                            <option key={i} value={ar.cod_puxada}>
                                                {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                            </option>
                                        ))
                                    )
                                    }
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label>Tipo de Acesso:</label>
                                <select className="form-control"
                                    value={(this.props.TipoLicenca === 3 ? 3 : this.state.SelTipLic)}
                                    onChange={this.setSelTipLic}

                                >

                                    <option value={0}>-- Selecione um Tipo Licença -- </option>
                                    {
                                        (this.props.TipoLicenca === 3 ?
                                            <option value={3}> 3 - Revenda </option>
                                            :
                                            cstTipoLicenca.map((ar, i) => (
                                                <option key={i} value={ar.Codigo}>
                                                    {ar.Codigo + " - " + ar.Descricao}
                                                </option>
                                            ))
                                        )
                                    }
                                    )

                                </select>
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-md-2">
                                <label for="select">Permissões:</label>
                            </div>
                            <div className="col-md-6">
                                <label>Copiar de:</label>
                                &nbsp;
                                <select id="copiar-de"
                                    onChange={this.setSelCopiarde}
                                // se usar Select options={camposUsuariosCop.map(i => ({ value: i.usuid, label: i.usulogin }))} 
                                >
                                    <option value="-1">-- Selecione um E-mail que deseje copiar os Acessos --</option>
                                    {camposUsuariosCop.map((ar, i) => (
                                        <option key={i} value={ar.usuid}>
                                            {ar.usulogin}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {/* </div> */}
                        {/* <div className="form-group"> */}
                        <br />
                        <div className="row">
                            <Select
                                onChange={this.setSelAcesso}
                                isMulti
                                value=
                                {
                                    (
                                        this.state.workTodosAcessos.map
                                            (
                                                (ar, i) =>
                                                    ar.selecionado === 2 ? { value: ar.mnuid, label: ar.mnudes } : ""
                                            )
                                    )
                                }
                                options=
                                {
                                    this.state.workTodosAcessos.map
                                        (
                                            (ar, i) =>
                                            (
                                                { value: ar.mnuid, label: ar.mnudes }
                                            )
                                        )
                                }
                            >

                            </Select>
                        </div>
                        {/* </div> */}
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}

const mapStateToProps = state => (
    {
        codUsuario: state.authRed.CodUsuario
        , nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario
        , todosCamposdeAcesso: state.authRed.vetorCmpAcsUsu
        , listaTodosEmails: state.cadastroRed.listaDadosTodos
        , steCadcamposBroker: state.cadastroRed.vetorCmpBrk
        , camposUsuarios: state.cadastroRed.vetorCmpUsu
        , existeemail: state.cadastroRed.RedExisteEmail
        , cmposcadacsdoEmail: state.cadastroRed.vetorCadCmpEmailAcs
        //Busca os Acessos do email do Auth
        //, camposacessodoEmail: state.authRed.vetorCmpEmailAcs
        //Busca os Acessos do email do Cadastro

    }

)
const mapDispatchToProps = dispatch => bindActionCreators(
    {

        getData
        , logout
        , getExcUpdataUsu
        , getBrokerCmps, getUsuCmps
        , postInclui, putSalva, getExisteEmail
        , getCadAcsEmail
        //Busca os Acessos do email do Auth
        //, getAcessosEmail
        //Busca os Acessos do email do Cadastro

    }
    , dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Cadastro)